l = require 'lib/localize'

functions =
  getPermLevelAltText: (level) ->
    return l(['board perms', level, 'short summary'])

  getPermLevelAltTextForBoard: (board) ->
    functions.getPermLevelAltText board.getPermLevel()

  getPermLevelIconClass: (level) ->
    if level == 'org'
      'organization-visible'
    else if level == 'company'
      'enterprise-dashboard'
    else
      level

  getPermLevelIconClassForBoard: (board) ->
    functions.getPermLevelIconClass board.getPermLevel()

module.exports = functions



// WEBPACK FOOTER //
// ./app/scripts/views/internal/board-display-helpers.coffee